import styled from 'styled-components';

import { IFacetOption } from 'shared/types/ConstructorFacet';
import { SearchFilterList } from 'search/components/searchGrid/SearchFilterList';
import { UnorderedList } from 'shared/components';

interface ISearchFilterGrid {
  filterOptions: Array<IFacetOption>;
  facetType: string;
  resultIds: Array<string>;
}

export const SearchFilterGrid = ({ filterOptions, facetType, resultIds }: ISearchFilterGrid) => {
  return (
    <SearchFilterGrid.Wrapper data-qa="search_filter_grid">
      <SearchFilterList filterOptions={filterOptions} facetType={facetType} resultIds={resultIds} />
    </SearchFilterGrid.Wrapper>
  );
};

SearchFilterGrid.Wrapper = styled.div`
  ${UnorderedList} {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 12px;
  }

  a {
    min-width: 40px;
  }
`;
